module.exports = [{
      plugin: require('/Users/iwatson/Projects/_personal/sweetweb-site/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/iwatson/Projects/_personal/sweetweb-site/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
